// extracted by mini-css-extract-plugin
export var formContainer = "_f6-0";
export var message = "_f6-1";